import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, Puser, User, UserService } from '../../shared';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: 'patsy.component.html',
  styleUrls: ['./style.component.css']
})
export class PatsyComponent implements OnInit {
  duplicateshow: any;
  alertShowed: boolean;
  public timealert = environment.timelimit;
  imageURL: string = environment.cloudeImageURL;
  resdata: string;
  bsConfig: { containerClass: string; showWeekNumbers: boolean; dateInputFormat: string; };
  dateformat: string;
  setmask: any;
  setmask1: any;
  maxlen: any;
  maxlen1: any;
  setlength: any;
  setlength1: any;
  codes: any = [];
  alterNo: any = [];
  modalRef: BsModalRef;
  showloader: boolean = false;
  resp: any;
  respass: string;
  imagearr: { filename: any; filetype: any; value: any; }[];
  dataimg: any;
  public defaultUl = './assets/img/users/addusericon.png'
  hospitalid: any;
  partnerdetail: any = {
    code: '+1,USA',
    emai: ""
  }
  public data: Object;
  PUser: Puser;
  public params: any;
  CurrentUser: User;
  apiurl: any = environment.api_url;
  tempMail: any;
  tempphone: any;
	prefLang: string = '';
  languageConfig = {
		"multiLanguageRequired" : false,
		"languages": []
	}

  languageSubscription: Subscription;

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private route: ActivatedRoute,
    public userService: UserService,
    private patientservice: PatientService,
    private router: ActivatedRoute,
    private modalService: BsModalService,
    private toast: ToastrService
  ) { 
    this.prefLang = this.userService.LoginDefaultLanguage;
  }

  ngOnInit() {
    this.params = JSON.parse(atob(window.localStorage['careId']))
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');

          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }

          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
          
            this.getPreferredLanguage();
        }

      }

    )
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        if (this.CurrentUser.item)
          this.hospitalid = this.CurrentUser.item.userAccountKey;
        ////console.log("id", this.hospitalid)
        if (this.route.snapshot.url[0].path != 'assessment') {
          this.CurrentUser.operationStatus = ''
        }
        this.userService
          .getcarepartnerdetails(this.params.name, this.resp.patientId)
          .subscribe(
            data => {
              for (var i = 0; i < data.length; i++) {
                this.partnerdetail = data[i];
                this.tempMail = this.partnerdetail.email ? this.partnerdetail.email : ''
                this.tempphone = this.partnerdetail.phone ? this.partnerdetail.phone : ''
                if (this.partnerdetail.phone)
                  this.partnerdetail.code = this.partnerdetail.teleCode + ',' + this.partnerdetail.teleCountryCode
                else {
                  // if (this.CurrentUser.item.language != 'en_uk') {
                  //   this.partnerdetail.code = '+1,USA'
                  // } else if (this.CurrentUser.item.language == 'en_uk') {
                  //   this.partnerdetail.code = '+44,UK'
                  // }
                  this.partnerdetail.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
                }
                if (this.partnerdetail.phoneOther) {
                  this.phoneOthervalue = true
                  this.partnerdetail.codeOther = this.partnerdetail.teleCodeOther + ',' + this.partnerdetail.teleCountryCodeOther
                }
                else {
                  // if (this.CurrentUser.item.language != 'en_uk') {
                  //   this.partnerdetail.code = '+1,USA'
                  // } else if (this.CurrentUser.item.language == 'en_uk') {
                  //   this.partnerdetail.code = '+44,UK'
                  // }
                  this.partnerdetail.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
                }
                this.tempCode = this.partnerdetail.code
                this.setnumb(this.partnerdetail.code)
                this.setnumb1(this.partnerdetail.codeOther)
                this.partnerdetail.otherPhoneType = this.partnerdetail.otherPhoneType ? this.partnerdetail.otherPhoneType : 1;
                this.prefLang = this.partnerdetail.preferredLanguage || this.userService.LoginDefaultLanguage;
                setTimeout(() => {
                  const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
                  if (cnDropElement) {
                    cnDropElement.value = this.prefLang;
                  }
                }, 500);
              }
              if (data[0].imagePath.search("default_") == -1)
                this.dataimg = this.imageURL + data[0].imagePath;
              else
                this.dataimg = this.defaultUl
              // //////console.log(data[0].imagePath);

            }

          );
      }
    )
    let self = this;
    self.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        self.codes = data
        ////console.log("code", data)
      })
    self.patientservice.getAlterNo()
      .subscribe(data => {
        self.alterNo = data
        self.partnerdetail.otherPhoneType = 1
        ////console.log("code", data)
      })


  }

  relationships = [
    {
      displayValue: this.userService.translateText('patient_portal.care_partner.spouse.label'),
      value: "Spouse"
    }, { 
      displayValue: this.userService.translateText('patient_portal.care_partner.child.label'),
      value: "Child"
    }, {
      displayValue:this.userService.translateText('patient_portal.care_partner.parent.label'),
      value: "Parent"
    }, {
      displayValue: this.userService.translateText('patient_portal.care_partner.other_family.label'),
      value: "Other Family"
    },  {
      displayValue: this.userService.translateText('patient_portal.care_partner.non_family.label'), 
      value: "Non-Family"
    }, {
      displayValue:  this.userService.translateText('patient_portal.care_partner.friend.label'), 
      value: "Friend"
    }, {
      displayValue: this.userService.translateText('patient_portal.care_partner.professional_caregiver.label'), 
      value: "Professional Caregiver"
    }, {
      displayValue: this.userService.translateText('patient_portal.care_partner.Unknown.label'),
      value: "Unknown"
    }];

  fileUpload(event) {
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      this.dataimg = events.currentTarget.result; // base64
      // //////console.log( this.dataimg);
      this.imagearr = [{
        filename: event.target.files[0].name,
        filetype: event.target.files[0].type,
        value: events.currentTarget.result.split(',')[1]
      }];
      // //////console.log(this.imagearr);


    }
  }
  btndisable: boolean
  editcare(ed, temppassword) {
    this.btndisable = true
    if (this.checkPhoneClear && !this.duplicateshow)
      this.phonechange(ed, temppassword)
    else if (this.checkEmailClear && !this.duplicateshow)
      this.emailchange(this.partnerdetail.email, ed, temppassword)
    else
      this.savedetails(ed, temppassword)
  }
  phonechange(car, sucessda) {
    let telecode: any;
    telecode = this.partnerdetail.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.partnerdetail.phone;

    if (this.partnerdetail.phone && this.tempphone != this.partnerdetail.phone) {
      let tempcode = this.tempCode.split(',')
      let temPhone = ''
      if (this.tempphone) {
        temPhone = tempcode[0] + '-' + this.tempphone
      }
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": telecode[0] + '-' + this.partnerdetail.phone,
        "addOrEdit": "edit",
        "updatingProfileRole": 20
      }
      this.userExists(data, car, sucessda)
    }
  }
  userExists(data, car, sucessda) {
    this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
      data => {
        if ((data.popUpStatus == 'true' && data.status == 'success') || data.message == 'User already Exist') {
          this.btndisable = false
          return;
        }
        else {
          this.savedetails(car, sucessda)
        }
      })
  }
  emailchange(event, car, sucessda) {
    this.email_val = event ? event : this.partnerdetail.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let data = {
        "oldEmail": this.tempMail ? this.tempMail : '',
        "newEmail": this.email_val,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": "edit",
        "updatingProfileRole": 20
      }
      this.userExists(data, car, sucessda)
    }
  }
  savedetails(ed, temppassword) {

    this.showloader = true;

    ed.value.updateimage = this.imagearr;
    if (this.imagearr == undefined) {
      ed.value.updateimage = [{}];
    }
    if (ed.value.phone == undefined || ed.value.phone == "") {
      ed.value.phone = ""
      ed.value.teleCode = ""
      ed.value.teleCountryCode = ""
    }
    else {
      let telecode = ed.value.code.split(',')
      ed.value.teleCode = telecode[0]
      ed.value.teleCountryCode = telecode[1]
    }
    if (ed.value.phoneOther == undefined || ed.value.phoneOther == "") {
      ed.value.phoneOther = ""
      ed.value.teleCodeOther = ""
      ed.value.teleCountryCodeOther = ""
    }
    else {
      let telecode = ed.value.code.split(',')
      ed.value.teleCodeOther = telecode[0]
      ed.value.teleCountryCodeOther = telecode[1]
    }
    if (!ed.value.otherPhoneType)
      ed.value.otherPhoneType = 1
    //////console.log(ed.value);
    ed.value["preferredLanguage"] = this.prefLang;
    if (window.localStorage['Puser'])
      this.userService.updatecarpa(this.params.name, window.localStorage['Puser'], ed.value)
        .subscribe(
          data => {


            //////console.log(data);
            this.showloader = false;
            this.btndisable = false
            if (data.saveStatus == 'false') {
              this.resdata = data.message;
              //this.resdata = "Email Id already exists";
              //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

            } else if (data.message == "Email address already exists") {
              this.resdata = this.userService.translateText('patient_portal.validations.email_already_exist.error_label');
              //this.resdata = "Email Id already exists";
              //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

            } else if (data.saveStatus == 'true') {
              this.resdata = "";
              this.userService.logAudit("updatecarepartner", 0).subscribe(data => { })
              this.respass = this.userService.translateText('patient_portal.display_messages.update_message')+" !!";
              this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            }
            else {
              // this.resdata = "Enter all fields";
              this.userService.logAudit("updatecarepartner", 0).subscribe(data => { })
              this.respass = this.userService.translateText('patient_portal.display_messages.update_message')+" !!";
              this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
            }
          }
        );


  }

  setnumber(e) {
    this.partnerdetail.phone = "";
    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength = data.Length;
          this.maxlen = data.Length + this.CurrentUser.item.length;
          if (data.Length == 11) {
            this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );

  }
  setnumber1(e) {
    this.partnerdetail.phoneOther = "";
    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.userService.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength1 = data.Length;
          this.maxlen1 = data.Length + this.CurrentUser.item.length;
          if (data.Length == 11) {
            this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );

  }
  setnumb(e) {
    let code, codeOther = []
    code = this.partnerdetail.code.split(',')
    if (this.partnerdetail.phoneOther)
      codeOther = this.partnerdetail.codeOther.split(',')
    if (code[0] + this.partnerdetail.phone == codeOther[0] + this.partnerdetail.phoneOther && this.partnerdetail.phoneOther) {
      this.toast.error(this.userService.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
        timeOut: this.timealert
      })
      return this.partnerdetail.phone = ''
    } else {
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.userService.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength = data.Length;
            this.maxlen = data.Length + this.CurrentUser.item.length;
          }
        );
    }

  }
  setnumb1(e) {
    let code, codeOther = []
    code = this.partnerdetail.code.split(',')
    if (this.partnerdetail.phoneOther)
      codeOther = this.partnerdetail.codeOther.split(',')
    if (code[0] + this.partnerdetail.phone == codeOther[0] + this.partnerdetail.phoneOther && this.partnerdetail.phone) {
      this.toast.error(this.userService.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
        timeOut: this.timealert
      })
      return this.partnerdetail.phoneOther = ''
    } else {
      let telecode = e.split(',')
      let codecoun = telecode[1]
      this.userService.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength1 = data.Length;
            this.maxlen1 = data.Length + this.CurrentUser.item.length;
          }
        );
    }

  }


  /////////////modelchange
  getEmaildata: any;
  email_val: any;
  onSelection(event, userdetails) {
    this.email_val = event ? event.target.value : this.partnerdetail.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let self = this;
      let data = {
        "oldEmail": this.tempMail ? this.tempMail : '',
        "newEmail": this.email_val,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": "edit",
        "updatingProfileRole": 20
      }
      this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
        data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.userService.getuserdetails(this.email_val)
                .subscribe(
                  data => {
                    if (data.firstName) {
                      self.getEmaildata = data
                      if (((!this.partnerdetail.firstName && !this.partnerdetail.lastName && !this.partnerdetail.email) || (data.firstName != this.partnerdetail.firstName) || (data.lastName != this.partnerdetail.lastName))) {
                        if (!this.modalRef1 || !this.modalRef1.content) {
                          this.modalRef1 = this.modalService.show(userdetails, {
                            class: 'modal-md',
                            backdrop: 'static'
                          });
                        }
                        // this.movable();
                      }
                    }
                  });
              return false;
            }
          } else if (self.partnerdetail.email) {
            self.partnerdetail.email = ""
            if (!this.alertShowed) {
              self.toast.error(this.userService.translateText('patient_portal.validations.email_already_exist.error_label'), '', {
                timeOut: this.timealert
              })
              this.alertShowed = true;
            }
            this.checkEmailClear = false
            return false;
          }
        })
    }
    else {
      return true;
    }

  }
  modalRef1: any;
  mobile_val: any;
  onSelection1(userdetails) {
    let telecode: any;
    telecode = this.partnerdetail.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.partnerdetail.phone;

    if (this.partnerdetail.phone && this.tempphone != this.partnerdetail.phone) {
      let self = this;
      let tempcode = this.tempCode.split(',')
      let temPhone = ''
      if (this.tempphone) {
        temPhone = tempcode[0] + '-' + this.tempphone
      }
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": telecode[0] + '-' + this.partnerdetail.phone,
        "addOrEdit": "edit",
        "updatingProfileRole": 20
      }
      this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
        data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.userService.getuserdetails(this.mobile_val)
                .subscribe(
                  data => {
                    if (data.firstName) {
                      self.getEmaildata = data
                      if (((!this.partnerdetail.firstName && !this.partnerdetail.lastName && !this.partnerdetail.email) || (data.firstName != this.partnerdetail.firstName) || (data.lastName != this.partnerdetail.lastName) || (data.email != this.partnerdetail.email))) {
                        if (!this.modalRef1 || !this.modalRef1.content) {
                          this.modalRef1 = this.modalService.show(userdetails, {
                            class: 'modal-md',
                            backdrop: 'static'
                          });
                        }

                        // this.movable();
                      }
                    }
                    ////console.log("getEmaildata", data)
                  });
              return false;
            }
          } else if (self.partnerdetail.phone) {
            self.partnerdetail.phone = ""
            this.toast.error(this.userService.translateText('patient_portal.validations.mobile_no_already_exist.error_label'), '', {
              timeOut: this.timealert
            })
            this.checkPhoneClear = false
          }
        });
    }


  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  tempCode: any;
  selection(status) {
    this.modalRef1.hide()
    this.modalRef1 = undefined;
    if (this.getEmaildata && status) {
      this.duplicateshow = status
      this.partnerdetail.firstName = this.getEmaildata.firstName;
      this.partnerdetail.phone = this.getEmaildata.phone;
      this.tempphone = this.getEmaildata.phone;
      this.partnerdetail.email = this.getEmaildata.email;
      this.tempMail = this.getEmaildata.email;
      this.partnerdetail.phoneOther = this.getEmaildata.phoneOther;
      this.partnerdetail.otherPhoneType = this.getEmaildata.otherPhoneType ? this.getEmaildata.otherPhoneType : 1;
      this.partnerdetail.lastName = this.getEmaildata.lastName;
      this.partnerdetail.gender = this.getEmaildata.gender;
      this.partnerdetail.code = this.getEmaildata.teleCode + ',' + this.getEmaildata.teleCountryCode;
      this.partnerdetail.codeOther = this.getEmaildata.teleCodeOther + ',' + this.getEmaildata.teleCountryCodeOther;
      this.dataimg = this.apiurl + this.getEmaildata.imagePath;

      if (this.partnerdetail.phone) {
        this.setnumb(this.partnerdetail.phone)
      }
      if (this.partnerdetail.phoneOther) {
        this.setnumb1(this.partnerdetail.phoneOther)
      }
      if (!this.getEmaildata.teleCode) {
        this.partnerdetail.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
      }
      if (!this.getEmaildata.teleCodeOther) {
        this.partnerdetail.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
      }
      this.tempCode = this.partnerdetail.code
    } else {
      this.partnerdetail.email = ''
      this.partnerdetail.phone = ''
      this.checkEmailClear = false
      this.checkPhoneClear = false
      this.partnerdetail.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
    }


  }


  //alternative no
  phoneOthervalue: any = false
  viewalterno(phoneOthervalue) {
    if (!phoneOthervalue) {
      this.phoneOthervalue = true
      this.partnerdetail.otherPhoneType = 1
      this.changeAlterNo()
    }
  }
  changeAlterNo() {
    if (this.CurrentUser.item.language != 'en_uk') {
      this.partnerdetail.codeOther = '+1,USA'
    } else if (this.CurrentUser.item.language == 'en_uk') {
      this.partnerdetail.codeOther = '+44,UK'
    }
    if (this.CurrentUser.item.clientTeleCode) {
      this.partnerdetail.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
    }
    this.partnerdetail.phoneOther = ''
  }
  @ViewChild('ed') myForm: NgForm;
  // setEmailorPhoneValidation(valuechange,event){
  //   console.log("event",event);
  //   if(event && !this.partnerdetail.email && !this.partnerdetail.phone){      
  //     this.myForm.form.get('email').setValidators([Validators.required]);
  //     this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
  //     this.myForm.form.get('email').updateValueAndValidity();

  //     this.myForm.form.get('phone').setValidators([Validators.required]);
  //     this.myForm.form.get('phone').updateValueAndValidity();      
  //   }else if(valuechange && !event){
  //     this.myForm.form.get('email').clearValidators();
  //     this.myForm.form.get('email').updateValueAndValidity();
  //     this.myForm.form.get('phone').clearValidators();
  //     this.myForm.form.get('phone').updateValueAndValidity();
  //   }
  // }
  setEmailorPhoneValidation(event) {
    console.log("event", event);
    if (event && !this.partnerdetail.email && !this.partnerdetail.phone) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else if (event && this.partnerdetail.email) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').clearValidators();
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else if (event && this.partnerdetail.phone) {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').clearValidators();
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
  }
  activate(template) {
    if (this.partnerdetail.onBehalf && !this.partnerdetail.email && !this.partnerdetail.phone) {
      this.modalRef1 = this.modalService.show(template, {
        class: 'modal-sm',
        backdrop: 'static'
      })
      this.movable();
    }
  }
  validateEmail(email) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

  }
  validatemail: any = false
  required: any = false
  checkEmail() {
    let self = this;
    let checkEmail = self.validateEmail(self.partnerdetail.email.toLowerCase())
    if (checkEmail || self.partnerdetail.email == '') {
      self.validatemail = false
    } else if (!checkEmail && self.partnerdetail.email) {
      self.required = true;
      self.validatemail = true
      self.toast.error(this.userService.translateText('patient_portal.validations.enter_a_valid_email.error_label'), '', {
        timeOut: this.timealert
      })

    }
  }


  checkPhoneClear: boolean;
  setPhoneValue: any;
  backupPhoneValue(event) {
    if (event) {
      this.checkPhoneClear = true;
      this.setPhoneValue = event;
      this.duplicateshow = false
    }
    else {
      this.checkPhoneClear = false;
    }

    // console.log("setPhoneValue",this.checkPhoneClear)
  }

  checkEmailClear: boolean;
  setEmailValue: any;
  backupEmailValue(event) {
    if (event) {
      this.checkEmailClear = true;
      this.setEmailValue = event;
      this.duplicateshow = false
    }
    else {
      this.checkEmailClear = false;
    }
    // console.log("setEmailValue",this.checkEmailClear)
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  getPreferredLanguage() {
		let targetEmail;
		if (this.CurrentUser && this.CurrentUser?.item?.email) {
			targetEmail = this.CurrentUser?.item?.email
		} 

		const credential = {
		  'userName': !targetEmail && !this.CurrentUser?.item?.phone ? null :  !targetEmail ? this.CurrentUser?.item?.clientTeleCode.replace("+",'') + "-" + this.CurrentUser?.item?.phone : targetEmail
		}
    if(!targetEmail && !this.CurrentUser?.item?.phone)
			credential['clientId'] = this.CurrentUser?.item?.userAccountKey || '';
    
		this.languageSubscription = this.userService.getLanguageConfig(credential).subscribe(
		  langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          this.languageConfig = langConfigRes;
        }
		});
	}
}